export default __webpack_public_path__ + "img/9975042a5439236799b169188d07e9d8.png";